import { IPublishInfoMessage } from '../../../redux/reducers';
import {
  ICheckPublishResponseMessageModel,
} from '../../../repositories/monolith-python/entities/CheckPublishResponseSchema';

export const mapMessage = (
  message: ICheckPublishResponseMessageModel | null | undefined,
): IPublishInfoMessage | null => {
  if (!message) {
    return null;
  }

  const { header, body, styleType } = message;

  return { header, body, styleType };
};
